module.exports = __webpack_public_path__ + "img/structure01.180a7018.svg";